var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-badge',{staticClass:"status-pill",class:{'cursor-pointer': _vm.btn && !_vm.disabled},attrs:{"id":_vm.id,"pill":"","variant":_vm.variant}},[_vm._v(" "+_vm._s(_vm.text || _vm.status)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }